// extracted by mini-css-extract-plugin
export default {"card":"pZ-z","carouselContainer":"qZ-z","carouselContent":"rZ-z"};